let date = new Date();
date.setFullYear(date.getFullYear() + 1);
export default {
  Number: '',
  IssueDate: new Date().toStringRu(),
  StartDate: new Date().toStringRu(),
  EndDate: date.toStringRu(),
  ContragentId: '',
  PartnerLegalId: '',
  ContragentName: '',
  ContragentType: '',
  OwnerLegalEntityId: '',
  CurrencyId: 1,
  Type: 1,
  IsPayed: false,
  IsUsed: false,
  IsOwner: false,
  OwnerId: '',
  OwnerName: '',
  Sum: 0,
  CreatorName: '',
  CreateDate: '',
  options: {
    legals: [],
  },
  Comment: '',
  rules: {
    Number: [
      {required: true, message: 'Введите номер сертификата', trigger: 'blur,change'},
    ],
    ContragentId: [
      {required: true, message: 'Выберите покупателя', type: 'number', trigger: 'blur,change'},
    ],
    Sum: [
      {required: true, min: 1, message: 'Введите сумму сертификата', type: 'number', trigger: 'blur'},
    ],
    OwnerLegalEntityId: [
      {required: true, message: 'Выберите фирму-владелеца', type: 'number', trigger: 'blur,change'},
    ],
    IssueDate: [
      {required: false, message: 'Введите', trigger: 'blur,change'},
    ],
    StartDate: [
      {required: false, message: 'Введите', trigger: 'blur,change'},
    ],
    EndDate: [
      {required: false, message: 'Введите', trigger: 'blur,change'},
    ],
    Type: [
      {required: false, message: 'Введите', trigger: 'blur,change'},
    ],
    Comment: [
      {max: 1024, message: 'Текст комментария не должен превышать 1024-ре символа', trigger: 'blur,change'},
    ],
  }
}
